/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Faq_A5Inputs */

const en_dr_faq_a5 = /** @type {(inputs: Dr_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not yet, by design — the evidence favors async writing before a synchronous reveal. A live mode is on the roadmap once usage shows rooms genuinely need it.`)
};

const id_dr_faq_a5 = /** @type {(inputs: Dr_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum, dan itu disengaja — bukti mendukung menulis asinkron dulu sebelum reveal serentak. Mode langsung ada di roadmap begitu data menunjukkan ruang benar-benar membutuhkannya.`)
};

/**
* | output |
* | --- |
* | "Not yet, by design — the evidence favors async writing before a synchronous reveal. A live mode is on the roadmap once usage shows rooms genuinely need it." |
*
* @param {Dr_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_faq_a5 = /** @type {((inputs?: Dr_Faq_A5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Faq_A5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_faq_a5(inputs)
	return en_dr_faq_a5(inputs)
});